import { useNumVisibleSubTimelines } from "components/Dashboard/Timeline/TimelineCardControls/timelinesStore";
import { useIsDarkMode } from "store/atoms";
import { useIsStorybook } from "utils/customHooks/storyHooks";
import {
  useHighlightedTags,
  useIsTimelineExpanded,
} from "./singleTimelineStore";
import {
  TAGHIGHLIGHT_EXPANDED_OFFSET_TOP,
  TagHighlightTimelineBackdrop,
  SkuOperatorTimelineBackdrop,
} from "./TagHighlightTimelineBackdrop";
import { Collapse } from "@mui/material";
import { memo } from "react";

export const BelowSingleTimelineRows = memo(() => {
  const [highlightedTags] = useHighlightedTags();

  const areAnyTagsHighlighted = highlightedTags.length > 0;
  const [isTimelineExpanded] = useIsTimelineExpanded();

  const [isDarkMode] = useIsDarkMode();
  const numVisibleSubTimelines = useNumVisibleSubTimelines();

  const timelineOffsetTop = isTimelineExpanded
    ? TAGHIGHLIGHT_EXPANDED_OFFSET_TOP - 2
    : 0;
  return (
    <CollapseStorybookFriendly in={areAnyTagsHighlighted || isTimelineExpanded}>
      <div
        className={`belowSingleTimelineSpacer BelowSingleTimelineRows`}
        style={{
          transform: `translateY(${timelineOffsetTop}px)`,
          transition: `transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)`,
        }}
      >
        <TagHighlightTimelineBackdrop
          className={`TagHightlightBackdrop ${isTimelineExpanded ? "" : "collapsed"}`}
          $isDarkMode={isDarkMode}
        >
          {areAnyTagsHighlighted ? null : (
            <div className="placeholderText">
              Click {'"'}Tag Highlight{'"'} to view tags here
            </div>
          )}
        </TagHighlightTimelineBackdrop>
        <CollapseStorybookFriendly in={isTimelineExpanded}>
          {[...new Array(numVisibleSubTimelines)].map((_, idx) => (
            <SkuOperatorTimelineBackdrop key={idx} />
          ))}
          <div style={{ height: TAGHIGHLIGHT_EXPANDED_OFFSET_TOP }} />
        </CollapseStorybookFriendly>
      </div>
    </CollapseStorybookFriendly>
  );
});
BelowSingleTimelineRows.displayName = "BelowSingleTimelineRows";

/** storybook doesn't behave with mui Portals (as in Collapse) */
function CollapseStorybookFriendly({
  in: isIn,
  ...props
}: { in: boolean } & any) {
  const isStorybook = useIsStorybook();

  return isStorybook ? (
    <div
      {...props}
      style={{ height: isIn ? "fit-content" : 0, overflow: "hidden" }}
    />
  ) : (
    <Collapse {...props} in={isIn} />
  );
}
